module.exports = __webpack_public_path__ + "img/ourTipp.ee3469f.webp";